import { render, staticRenderFns } from "./ReportFilters.vue?vue&type=template&id=537a12c7&"
import script from "./ReportFilters.vue?vue&type=script&lang=ts&"
export * from "./ReportFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports